<template>
    <svg class="pc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path v-for="(path, index) in paths" :key="index" :d="path" />
    </svg>
</template>

<script>
const icons = {
    search: ['m21 21-4.4-4.4', 'M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0'],
    chevron: ['m9 5 7 7-7 7'],
    game: ['M7 7h10c3 0 4 2 5 9 .4 3-2 4-4 2l-3-3H9l-3 3c-2 2-4.4 1-4-2C3 9 4 7 7 7Z', 'M6 10v5m-2.5-2.5h5', 'M16 11h.01M19 14h.01'],
    gift: ['M3 8h18v4H3z', 'M5 12v9h14v-9', 'M12 8v13', 'M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z'],
    crown: ['m2 7 5 4 5-7 5 7 5-4-3 12H5L2 7Z', 'M5 22h14'],
    people: ['M16 21v-3a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v3', 'M13 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0', 'M17 3a3.5 3.5 0 0 1 0 7', 'M21 21v-3a4 4 0 0 0-3-4'],
    shield: ['m12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6l8-4Z', 'M12 8v8m-4-4h8'],
    calendar: ['M5 5h14a2 2 0 0 1 2 2v13H3V7a2 2 0 0 1 2-2Z', 'M7 2v6m10-6v6M3 10h18', 'm8 15 3 3 5-5'],
    wallet: ['M20 7H4V4l12-2v5', 'M4 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16V7', 'M20 12h-5v5h5', 'M16.5 14.5h.01'],
    share: ['M8 12 17 5M8 13l9 6', 'M8 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0', 'M22 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0', 'M22 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0'],
    clock: ['M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0', 'M12 6v6l4 2'],
    heart: ['M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z'],
    globe: ['M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0', 'M2 12h20', 'M12 2c5 5 5 15 0 20-5-5-5-15 0-20Z'],
    download: ['M12 2v14m-5-5 5 5 5-5', 'M3 16v6h18v-6'],
    headset: ['M3 14v-3a9 9 0 0 1 18 0v3', 'M3 12H2v7h4v-7H3Zm18 0h1v7h-4v-7h3Z', 'M19 19a4 4 0 0 1-4 4h-3'],
    profile: ['M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0', 'M4 22v-3a8 8 0 0 1 16 0v3H4Z']
}

export default {
    props: { name: { type: String, required: true } },
    computed: {
        paths() { return icons[this.name] || icons.game }
    }
}
</script>

<style scoped>
.pc-icon { width: 24px; height: 24px; flex: 0 0 auto; vertical-align: middle; }
</style>
